export default function TitleHeader({
  title,
  // sp,
  icon,
  // colorTitle = "black",
  // colorSp = "text-[#7303a7]",
  className,
}) {
  return (
    <h3
      className={`font-extrabold text-4xl mb-20 flex items-center justify-center gap-2 header ${className}`}
    >
      <span>{icon}</span> {title}
      {/* <span
      className={`${colorSp}`}
      >
        {sp}
      </span> */}
    </h3>
  );
}
